import { observable, computed, action } from "mobx";
import {
  RStatus,
  UserInfo,
  MachineItem,
  SubAccount,
  CurrentSub,
  FundBalance,
  UserBalance,
  MinerGroup,
  CurrencyCoinFee,
  ExchangeRate,
  EarnData,
  AccountSummary,
  MoneyFlag,
} from "@/models/";

import API from "@/apis";
import config from "@/config.json";
import moment from "moment";
const { pool_uuid } = config;
import { CoinHelper } from "@/utils";

import { rootStore } from "@/index";

export class PriceStore {
  @observable public btcDifficulty: number;
  @observable public bsvDifficulty: number;
  @observable public bchDifficulty: number;
  @observable public btcReward: number;
  @observable public bsvReward: number;
  @observable public bchReward: number;

  @observable public btc2cny: number;
  @observable public bsv2cny: number;
  @observable public bch2cny: number;
  @observable public btc2usd: number;
  @observable public bsv2usd: number;
  @observable public bch2usd: number;
}

export class Price extends PriceStore {
  constructor() {
    super();

    this.btcDifficulty = 0;
    this.bsvDifficulty = 0;
    this.bchDifficulty = 0;
    this.btcReward = 0;
    this.bsvReward = 0;
    this.bchReward = 0;
    this.btc2cny = 0;
    this.bsv2cny = 0;
    this.bch2cny = 0;
    this.btc2usd = 0;
    this.bsv2usd = 0;
    this.bch2usd = 0;
  }

  @action
  getDayEarn = async () => {
    try {
      const { data } = await API.Open.getDayEarn();
      const {
        BSV_difficulty,
        BSV_reward,
        BTC_difficulty,
        BTC_reward,
        BCH_difficulty,
        BCH_reward,
        cny2btc_bsv,
      } = data.data;
      const { btc2cny, bsv2cny, bch2cny, bch2usd, btc2usd, bsv2usd } = cny2btc_bsv;

      let btcDifficulty = BTC_difficulty;
      let bsvDifficulty = BSV_difficulty;
      let bchDifficulty = BCH_difficulty;

      let btcReward = +CoinHelper.amount2bsv(BTC_reward);
      let bsvReward = +CoinHelper.amount2bsv(BSV_reward);
      let bchReward = +CoinHelper.amount2bsv(BCH_reward);

      this.btcDifficulty = btcDifficulty;
      this.bsvDifficulty = bsvDifficulty;
      this.bchDifficulty = bchDifficulty;
      this.btcReward = btcReward;
      this.bsvReward = bsvReward;
      this.bchReward = bchReward;
      this.btc2cny = btc2cny;
      this.bsv2cny = bsv2cny;
      this.bch2cny = bch2cny;
      this.btc2usd = btc2usd;
      this.bsv2usd = bsv2usd;
      this.bch2usd = bch2usd;
    } catch (error) {}
    // try {
    //   const { data } = await API.Open.getBchPrice();
    //   const { difficulty, reward_block } = data.data;
    //   this.bchDifficulty = difficulty;
    //   this.bchReward = reward_block / 1e8;
    //   localStorage.setItem("bchDiff", difficulty);
    //   localStorage.setItem("bchReward", this.bchReward.toString());
    // } catch (error) {
    //   this.bchDifficulty = Number(localStorage.getItem("bchDiff"));
    //   this.bchReward = Number(localStorage.getItem("bchReward"));
    // }
  };

  @computed
  get moneyFlag() {
    return rootStore.locale.isCN ? MoneyFlag.cny : MoneyFlag.usd;
  }

  @computed
  get bsvPrice() {
    return rootStore.locale.isCN ? this.bsv2cny : this.bsv2usd;
  }

  @computed
  get btcPrice() {
    return rootStore.locale.isCN ? this.btc2cny : this.btc2usd;
  }

  @computed
  get bchPrice() {
    return rootStore.locale.isCN ? this.bch2cny : this.bch2usd;
  }

  // 每日coin收益 checked
  calcDayEarns = (computingPower, reward, diff) => {
    return (computingPower * Math.pow(10, 12) * 86400 * reward) / (Math.pow(2, 32) * diff);
  };

  @computed
  get bsvCoinProfit() {
    // console.log(
    //   "=======bsvDifficulty",
    //   this.bsvDifficulty,
    //   this.bsvReward,
    //   this.calcDayEarns(1, this.bsvReward, this.bsvDifficulty)
    // );
    return this.calcDayEarns(1, this.bsvReward, this.bsvDifficulty);
  }

  @computed
  get btcCoinProfit() {
    return this.calcDayEarns(1, this.btcReward, this.btcDifficulty);
  }

  @computed
  get bchCoinProfit() {
    return this.calcDayEarns(1, this.bchReward, this.bchDifficulty);
  }

  @computed
  get bsvLegacyProfit() {
    return this.bsvCoinProfit * this.bsvPrice;
  }

  @computed
  get btcLegacyProfit() {
    return this.btcCoinProfit * this.btcPrice;
  }

  @computed
  get bchLegacyProfit() {
    return this.bchCoinProfit * this.bchPrice;
  }
}

export default Price;
